export default function Card71(){
    return(
        <div>
            {/*<div className={"text-4xl p-8 bg-gradient-to-r from-indigo-200 via-purple-200 to-pink-200"}>*/}
            {/*    <div className={"text-center font-bold"}>Card 71 :</div>*/}
            {/*</div>*/}
            <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
                <div class="lg:grid lg:grid-cols-12 lg:gap-16 lg:items-center">
                    <div class="lg:col-span-7">
                        <div class="grid grid-cols-12 gap-2 sm:gap-6 items-center lg:-translate-x-10">
                            <div class="col-span-4">
                                <img class="rounded-xl opacity-50" src="https://dummyimage.com/230x170" alt="IDescription"/>
                            </div>

                            <div class="col-span-3">
                                <img class="rounded-xl opacity-50" src="https://dummyimage.com/150x240" alt="IDescription"/>
                            </div>

                            <div class="col-span-5">
                                <img class="rounded-xl opacity-50" src="https://dummyimage.com/260x400" alt="IDescription"/>
                            </div>
                        </div>
                    </div>

                    <div class="mt-5 sm:mt-10 lg:mt-0 lg:col-span-5">
                        <div class="space-y-6 sm:space-y-8">
                            <div class="space-y-2 md:space-y-4">
                                <h2 class="font-bold text-3xl lg:text-4xl text-gray-800 dark:text-gray-200">
                                    Collaborative tools to design user experience
                                </h2>
                                <p class="text-gray-500">
                                    Use our tools to explore your ideas and make your vision come true. Then share your work easily.
                                </p>
                            </div>
                            
                            <ul class="space-y-2 sm:space-y-4">
                                <li class="flex space-x-3">
                                    <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
              <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </span>

                                    <span class="text-sm sm:text-base text-gray-500">
              <span class="font-bold">Less routine</span> – more creativity
            </span>
                                </li>

                                <li class="flex space-x-3">
                                    <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
              <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </span>

                                    <span class="text-sm sm:text-base text-gray-500">
              Hundreds of thousands saved
            </span>
                                </li>

                                <li class="flex space-x-3">
                                    <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
              <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </span>

                                    <span class="text-sm sm:text-base text-gray-500">
              Scale budgets <span class="font-bold">efficiently</span>
            </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}